"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _decorators = require("../../../../decorators");
var _mediaConfig = require("../../../../media-config");
var _mediaUtils = require("../../../../utils/media-utils");
var _clone = _interopRequireDefault(require("lodash/clone"));
var _CloudinaryPictureWithControls = _interopRequireDefault(require("../../../CloudinaryPictureWithControls"));
var _VideoPlayer = require("../../../VideoPlayer");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
//helpers

//components

var StepMediaComponent = function StepMediaComponent(_ref) {
  var autoplayVideo = _ref.autoplayVideo,
    imageSizes = _ref.imageSizes,
    mediaUrl = _ref.mediaUrl,
    _ref$metadata = _ref.metadata,
    metadata = _ref$metadata === void 0 ? {} : _ref$metadata,
    shouldShowSpinnerWhileLoading = _ref.shouldShowSpinnerWhileLoading;
  if ((0, _mediaUtils.isVideoUrl)(mediaUrl)) {
    var type = (0, _mediaUtils.getExtensionFromUrl)(mediaUrl);
    var eagerCacheConfig = (0, _clone["default"])(_mediaConfig.EAGER_CACHE['video'][0]);
    if (metadata.enableAudio) {
      delete eagerCacheConfig.audio_codec;
    }
    var options = (0, _mediaUtils.generateOptionString)(eagerCacheConfig);
    return /*#__PURE__*/_react["default"].createElement(_VideoPlayer.VideoPlayerDesktop, {
      autoplayVideo: autoplayVideo,
      muted: !metadata.enableAudio,
      poster: (0, _mediaUtils.getThumbnail)(mediaUrl),
      src: (0, _mediaUtils.getCloudinaryVideoUrl)(mediaUrl, type, options),
      type: "video/".concat((0, _mediaUtils.getFixedExtensionFromUrl)(mediaUrl))
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_CloudinaryPictureWithControls["default"], {
    metadata: metadata,
    aspectRatio: 4 / 3,
    src: mediaUrl,
    sizes: imageSizes,
    shouldShowSpinnerWhileLoading: shouldShowSpinnerWhileLoading,
    shouldShowOverlayShapes: true
  });
};
var _default = exports["default"] = (0, _decorators.styleable)(StepMediaComponent);
//# sourceMappingURL=index.js.map